
import { defineComponent } from "vue";
import Nav from "./navbar/Nav.vue";
import NavLink from "./navbar/NavLink.vue";
import Icon from "@moonlight/vue3/components/Icon.vue";
import Logo from "@moonlight/vue3/components/Logo.vue";

export { Nav, NavLink };
export default defineComponent({
  components: { Nav, Icon, Logo },
  props: {
    isOpenAsideMenu: {
      type: Boolean,
    },
    hasAsideMenu: {
      type: Boolean,
    },
  },
});
